import getConfig from 'next/config';
// @ts-ignore
import cloudPayments from 'cloudpay.js';
import { noop } from 'lodash';
import { NextRouter } from 'next/router';
import { CURRENCY_CODES_BY_SYMBOL } from '@/core/constants';
import { createAuthorizationHeader, instanceFetch } from '@/fetch';
import { LocalStorageService, parseJwt } from '@/helper';

interface ICheckoutProps {
  sendAffiseEvent: typeof noop;
  router: NextRouter;
  total?: number;
  currency?: string;
  isExtension?: boolean;
  licenseId?: number;
  priceId?: string;
  licenseLogin?: string;
  setLoading?: (arg: boolean) => void;
  originalPrice: number;
  promocode: string;
}

interface ICloudpaymentsPayload {
  code: string;
  email: string;
  message: string | null;
  success: boolean;
}

export const createCheckout = async ({
  sendAffiseEvent,
  router,
  total,
  currency,
  isExtension,
  licenseId,
  licenseLogin,
  setLoading,
  originalPrice,
  promocode,
}: ICheckoutProps) => {
  const { email, userId } = parseJwt();

  await (async function () {
    const lng = LocalStorageService.get('language') || DEFAULT_LANG;
    const urls = {
      successUrl: `${window.location.origin}/${lng}/terminal/checkout/success?sessionId={CHECKOUT_SESSION_ID}`,
      cancelUrl: `${window.location.origin}/${lng}/terminal/checkout/cancel?sessionId={CHECKOUT_SESSION_ID}`,
    };
    const initPayment = await getInitPayment({
      currency,
      originalPrice,
      urls,
      isExtension,
      licenseId,
      promocode,
    });
    const { publicId, invoiceId } = initPayment;
    const widget = new cloudPayments.cp.CloudPayments();
    const currentCurrency = CURRENCY_CODES_BY_SYMBOL[currency];
    widget.pay(
      'charge',
      {
        publicId,
        description: 'TigerTrade',
        amount: total,
        currency: currentCurrency,
        accountId: userId,
        invoiceId,
        email,
        skin: 'modern',
      },
      {
        onSuccess() {
          // success
          // действие при успешной оплате
        },
        onFail() {
          // fail
          // действие при неуспешной оплате
        },
        onComplete(params: ICloudpaymentsPayload) {
          if (params.success) {
            (async function () {
              const purchaseId = localStorage.getItem('purchaseId');
              checkoutController(
                currentCurrency,
                total,
                isExtension,
                licenseId ? String(licenseId) : undefined,
                licenseLogin,
                invoiceId,
                originalPrice,
                promocode
              );
              setLoading(true);
              await sendAffiseEvent('Purchase', purchaseId);
              router.push(
                `${window.location.origin}/${lng}/terminal/checkout/success?sessionId=${invoiceId}`
              );
            })();
          }
          // Вызывается как только виджет получает от api.cloudpayments ответ с результатом транзакции.
          // например вызов вашей аналитики Facebook Pixel
        },
      }
    );
  })();
};

export const checkoutStatus = (status, sessionId, setStatusChecked) => {
  const headers = createAuthorizationHeader();
  const URL = `/checkout/${status}${sessionId ? `?sessionId=${sessionId}` : ''}`;
  return instanceFetch.get(URL, headers).finally(() => {
    setStatusChecked(true);
  });
};

export const getInitPayment = async ({
  currency,
  originalPrice,
  urls,
  isExtension,
  licenseId,
  promocode,
}) => {
  const headers = createAuthorizationHeader();
  const URL = '/checkout';

  const body = {
    licenseId,
    extension: isExtension,
    currency: CURRENCY_CODES_BY_SYMBOL[currency],
    originalPrice: `${originalPrice}.00`,
    ...urls,
    promocode,
  };

  const initPayment = await instanceFetch.post(URL, body, headers);
  return initPayment;
};

export const checkoutController = (
  currency,
  price,
  isExtension: string | undefined | boolean = 'false',
  licenseId,
  licenseLogin,
  invoiceId: string,
  originalPrice: number,
  promocode: string
) => {
  const headers = createAuthorizationHeader();
  const URL = `/checkout/cp-success`;
  return instanceFetch
    .post(
      URL,
      {
        currency,
        invoiceId,
        isExtension,
        licenseId,
        licenseLogin,
        price,
        originalPrice,
        promocode,
      },
      headers
    )
    .finally(() => {});
};

export const sendPromoCode = (code: string, currency: string, price: number) => {
  const headers = createAuthorizationHeader();
  currency = CURRENCY_CODES_BY_SYMBOL[currency];
  const URL = `/promo/apply`;
  return instanceFetch
    .post(
      URL,
      {
        code,
        currency,
        price,
      },
      headers
    )
    .finally(() => {});
};

const DEFAULT_LANG = 'en';
/* export const checkoutController = (
  price,
  isExtension: string | undefined | boolean = 'false',
  licenseId = '',
  invoiceId: string
) => {
  const headers = createAuthorizationHeader();
  const URL = `/public/api/v1/checkout`;
  return instanceFetch
    .post(
      URL,
      {
        currency: 'RUB',
        invoiceId,
        isExtension,
        licenseId,
        licenseLogin: '',
        price,
      },
      headers
    )
    .finally(() => {});
};*/
